<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
  <path d="M150,0a19.74,19.74,0,0,0-19.74,19.74V130.26H19.74a19.74,19.74,0,0,0,0,39.48H130.26V280.26a19.74,19.74,0,0,0,39.48,0V169.74H280.26a19.74,19.74,0,0,0,0-39.48H169.74V19.74A19.74,19.74,0,0,0,150,0Z"/>
</svg>
